export enum RoleTypes {
	INTERNAL_ROLE = 'INTERNAL',
	EXTERNAL_ROLE = 'EXTERNAL',
	UNDEFINED = '',
}
